<template>
<div id="main" class="column is-9">
			<Spinner size="huge" v-if="!idle"></Spinner>
			<section class="profile" v-if="idle">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							Profile
						</p>
						</header>
						<div class="card-table">
							<div class="content">
								<div class="columns">
									<div class="column">
										<form>
											<h3>Password</h3>
											<div class="field is-maxed">
												<a class="button is-primary is-small" @click="passwordOpen = true">></a>
											</div>
											<h3>Contact Information</h3>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkFirst" :class="{'is-danger': errors.first}"
													v-model.trim="profile.first"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-user"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.first">
													{{ errors.first }}
												</p>
											<label class="label">Last Name</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkLast" :class="{'is-danger': errors.last}"
													v-model.trim="profile.last"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-user"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.last">
													{{ errors.last }}
												</p>
											<label class="label">Address 1</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkAddress1" :class="{'is-danger': errors.address1}" 
													v-model.trim="profile.address1"
													type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.address1">
													{{ errors.address1 }}
												</p>
											<label class="label">Address 2</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkAddress2" :class="{'is-danger': errors.address2}" 
													v-model.trim="profile.address2"
													type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.address2">
													{{ errors.address2 }}
												</p>
											<label class="label">Country</label>
											<div class="field is-maxed">
												<p class="control has-icons-left">
												<span class="select is-small">
												<select @change="checkCountry" :class="{'is-danger': errors.country}" v-model="profile.country">
													<option selected="select is-smalled" value="">Select Country</option>
													<option v-for="country in countries" :key="country.country_code" :value="country.country_code">{{ country.country_name }}</option>
												</select>
												</span>
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</p>
											</div>
												<p class="help is-danger" v-if="errors.country">
													{{ errors.country }}
												</p>
											<label class="label">Zip/Postal Code</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkPostalCode" :class="{'is-danger': errors.postal_code}" 
													v-model.trim="profile.postal_code"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.postal_code">
													{{ errors.postal_code }}
												</p>
											<label class="label">City</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkCity" :class="{'is-danger': errors.city}" 
													v-model.trim="profile.city"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.city">
													{{ errors.city }}
												</p>
											<label class="label">{{ regionLabel }}</label>
											<div class="field is-maxed">
												<p class="control has-icons-left">
												<span class="is-small is-expanded" :class="{'select is-expanded': regionDomestic, 'input': !regionDomestic}">
												<select v-model="profile.region" v-if="regionDomestic">
													<option selected="select is-smalled" value="">Select State/Prov.</option>
													<option v-for="state in stateList" :key="state.state_abbr" :value="state.state_abbr">{{state.state_name}}</option>
												</select>
												<input class="input is-small" 
													@change="checkRegion" :class="{'is-danger': errors.region}" 
													v-model.trim="profile.region"
													v-if="!regionDomestic"
												type="text" placeholder="">
												</span>
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</p>
											</div>
												<p class="help is-danger" v-if="errors.region">
													{{ errors.region }}
												</p>
											
											<label class="label">Email</label>
											<div class="field has-addons is-maxed">
												<div class="control has-icons-left has-icons-right is-expanded">
												<input class="input is-small" type="email" 
													@change="checkEmail" :class="{'is-danger': errors.email}" 
													v-model.trim="profile.email"
												placeholder="" value="">
												<span class="icon is-small is-left">
												<i class="fa fa-envelope"></i>
												</span>
												<span class="icon is-small is-right">
												<i class="fa fa-exclamation-triangle"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.email">
													{{ errors.email }}
												</p>
											<label class="label">Phone Numbers</label>
											<div class="field is-maxed">
												<a class="button is-primary is-small" @click="phonesOpen = true">></a>
											</div>	
											<div class="field is-grouped is-maxed">
												<div class="control">
													<button class="button is-small is-link" @click.prevent="save()">Submit</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</section>
			<PhonesModal v-if="phonesOpen" :phones="profile.phones" :id="user_id" @close="phonesOpen = false" />
			<PasswordModal v-if="passwordOpen" @close="passwordOpen = false" />
		</div>
</template>

<script>
	import countries from "../../countries.js"
	import states from "../../states.js"
	import PhonesModal from "../shared/PhonesModal.vue"
	import PasswordModal from "../shared/ChangePasswordModal.vue"
	import Spinner from 'vue-simple-spinner'

	export default {
		components: {
			PhonesModal,
			PasswordModal,
			Spinner
		},
		data() {
			return {
				countries: countries,
				states: states,
				user_id: null,
				languagesOpen: false,
				phonesOpen: false,
				passwordOpen: false,
				errors: {
					first: null,
					last: null,
					address1: null,
					address2: null,
					postal_code: null,
					city: null,
					region: null,
					country: null,
					email: null,
					phone: null,
				},
				profile: {
					first: "",
					last: "",
					address1: "",
					address2: "",
					postal_code: "",
					phone_type: 1,
					city: "",
					region: "",
					country: "",
					email: "",
					phones: [],
					country_code: 1,
				},
				idle: false
			}
		},
		methods: {
			checkFirst() {
				this.errors.first = null
				if (this.profile.first === "") {
					this.errors.first = "First Name is required"
				} else if (this.profile.first.length > 50) {
					this.errors.first = "First Name is invalid"
				}

				return this.errors.first === null
			},
			checkLast() {
				this.errors.last = null
				if (this.profile.last == "") {
					this.errors.last = "Last Name is required"
				} else if (this.profile.last.length > 50) {
					this.errors.last = "Last Name is invalid"
				}

				return this.errors.last === null
			},
			checkAddress1() {
				this.errors.address1 = null
				if (this.profile.address1 == "") {
					this.errors.address1 = "Address1 is required"
				} else if (this.profile.address1.length > 99) {
					this.errors.address1 = "Address1 is invalid"
				}

				return this.errors.address1 === null
			},
			checkAddress2() {
				this.errors.address2 = null
				if (this.profile.address2.length > 99) {
					this.errors.address2 = "Address2 is invalid"
				}

				return this.errors.address2 === null
			},
			checkPostalCode() {
				this.errors.postal_code = null

				if(this.profile.postal_code === "") {
					this.errors.postal_code = "Zip/Postal Code is required"
				} else if (/^\d{5}$/.test(this.profile.postal_code) && this.profile.country === "US") {
					this.$root.$data.getters.getCityState(this.$root.$data.state, this.profile.postal_code).then((cs) => {
						if (cs.length > 0) {
							this.profile.city = cs[0].city
							this.profile.region = cs[0].state
						}
					})
				} else {
					this.errors.postal_code = "Zip/Postal Code is invalid"
				}

				return this.errors.postal_code === null
			},
			checkCity() {
				this.errors.city = null
				if (this.profile.city === "") {
					this.errors.city = "City is required"
				} else if (this.profile.city.length > 99) {
					this.errors.city = "City is invalid"
				}

				return this.errors.city === null
			},
			checkRegion() {
				this.errors.region = null
				if (this.profile.region === "") {
					this.errors.region = "State/Region is required"
				} else if (this.profile.region.length > 99) {
					this.errors.region = "State/Region is invalid"
				}

				return this.errors.region === null
			},
			checkCountry() {
				this.errors.country = null

				if (this.profile.country != "") {
					this.profile.country_code = parseInt(this.countries.filter((c) => c.country_code === this.profile.country)[0].intl_prefix.trim())
				} else{
					this.profile.country_code = 1
					this.errors.country = "Country required"
				}

				return this.errors.country === null
			},
			checkEmail() {
				this.errors.email = null
				if (this.profile.email === "") {
					this.errors.email = "Email is required"
				} if (this.profile.email.length > 99) {
					this.errors.email =- "Email is not valid"
				}

				return this.errors.email === null
			},
			async valid() {
				let valid = true
				valid = this.checkFirst() && valid
				valid = this.checkLast() && valid
				valid = this.checkAddress1() && valid
				valid = this.checkAddress2() && valid
				valid = this.checkCountry() && valid
				valid = this.checkPostalCode() && valid
				valid = this.checkCity() && valid
				valid = this.checkRegion() && valid
				valid = this.checkEmail() && valid

				return valid
			},
			async save() {
                if (this.profile.address2 === null) {
					this.profile.address2 = ""
                }
                
				if (await this.valid()) {
				try {
					await this.$root.$data.setters.updateManagerProfile(this.$root.$data.state, this.profile)
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Profile Updated',
						text: 'Your Profile was updated',
					})
					this.$router.push("/dashboard")
				} catch{ return; }
				}
			}
		},
		computed: {
			stateList() {
				if (this.profile.country !== "") {
					return this.states.filter((s) => s.country_abbr == this.profile.country)
				}
				return []
			},
			regionDomestic() {
				return ["", "US", "CA"].includes(this.profile.country)
			},
			regionLabel() {
				if (["", "US", "CA"].includes(this.profile.country)) {
					return "State/Prov"
				}
				return "Region"
			},
		},
		async created() {
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			this.profile = await this.$root.$data.getters.getManagerProfile(this.$root.$data.state)
			this.idle = true
		}
	}
</script>